<script setup>
import Header from "@/views/ecosystem/settings/Header.vue";
import constants from "@/constants/constants";
import {useStore} from "vue2-helpers/vuex";
import {onMounted, ref, watch} from "vue";
import {triggerUpsell} from "@/composables/useStoreActions";
import subscriptionsService from "@/services/subscriptions.service";

const store = useStore();
const subscription = ref(null);

watch(() => store.getters.isPremium, value => {
    if (value) {
        getSubscription();
    }
})

onMounted(() => {
    getSubscription();
})

async function getSubscription() {
    const {data} = await subscriptionsService.getActiveSubscription();

    if (data) {
        subscription.value = data;
    } else {
        subscription.value = {
            price: 3750,
            type: 'quarterly'
        };
    }
}
</script>

<template>
    <div>
        <Header/>

        <div class="account-page-v2">
            <div>
                <header class="account-page__header">
                    <h6 class="heading6">Account type</h6>
                </header>

                <div class="account-plan">
                    <div v-if="store.state.accountType === 'free'" class="account-plan__item account-plan__item--active">
                        <h6 class="heading6">Explorer Network</h6>

                        <div class="account-plan__item__price"><big>$0</big> /yr</div>

                        <p>Get started at no cost</p>

                        <ul class="account-plan__list-check">
                            <li v-for="(item, index) in constants.ecosystemAccountTypesFeatures[store.state.accountType]" :key="index">{{item}}</li>
                        </ul>

                        <footer class="account-plan__item__footer">
                            <button class="ui-button ui-button--md" disabled="disabled">Current Plan</button>
                        </footer>
                    </div>

                    <div v-if="subscription" class="account-plan__item account-plan__item--pro">
                        <h6 class="heading6">SwitchPitch Pro</h6>

                        <div class="account-plan__item__price"><big>${{subscription.price.toLocaleString()}}</big> /{{ subscription.type }}</div>

                        <ul class="account-plan__list-check">
                            <li v-for="(item, index) in constants.ecosystemAccountTypesFeatures['premium']" :key="index">{{item}}</li>
                        </ul>

                        <footer class="account-plan__item__footer">
                            <button v-if="store.state.accountType === 'premium'" class="ui-button ui-button--md" disabled="disabled">Current Plan</button>
                            <button v-else class="ui-button ui-button--md" @click="triggerUpsell(store)">Upgrade</button>
                        </footer>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
